import { render, staticRenderFns } from "./BoxCreate.vue?vue&type=template&id=948a1ce4&"
import script from "./BoxCreate.vue?vue&type=script&lang=ts&"
export * from "./BoxCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports